import React from 'react';

import { FacetAccordion } from '@components';
import { Typography, Tooltip } from 'gd-design-library';
import styles from './ColorFacetTerms.module.scss';

import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const CN = 'color-facet-terms';
const colorFacetTermsWrapper = `${CN}__wrapper`;
const colorFacetTermsColor = `${CN}__color`;
const colorFacetTermsColorSelected = `${colorFacetTermsColor}--selected`;
const colorFacetTermsColorOther = `${colorFacetTermsColor}--other`;
const colorFacetTermsColorWhite = `${colorFacetTermsColor}--white`;

type ColorChangeHandler = (baseColor: string) => void;

interface ColorFacetTermsProps {
  label?: string
  colors: string[];
  selectedColors: string[];
  selectColor: ColorChangeHandler;
  deleteColor: ColorChangeHandler;
}

export const ColorFacetTerms: React.FC<ColorFacetTermsProps> =
({ label = 'Color', colors, selectedColors, selectColor, deleteColor }) => {
  const selectedButNotPresentInColors = selectedColors.filter(color => !colors.includes(color));
  const noColorsAvailable = !colors.length && !selectedButNotPresentInColors.length;

  // set 'Other' color as last one
  const sortedColors = [ ...colors ];
  const otherValue = 'Other';
  sortedColors.sort((a, b) => a === otherValue ? 1 : b === otherValue ? -1 : 0);

  const onClick = (color: string): void => {
    if (selectedColors.includes(color)) {
      deleteColor(color);
    } else {
      selectColor(color);
    }
  };

  return (
    <FacetAccordion label={ label }>
      <div className={ cx(colorFacetTermsWrapper) } >
        {selectedButNotPresentInColors.map(color => (
          <Tooltip key={ color } content={ color } position='bottom'>
            <span
              className={ cx(
                colorFacetTermsColor,
                colorFacetTermsColorSelected,
                {
                  [colorFacetTermsColorOther]: color === 'Other',
                  [colorFacetTermsColorWhite]: color === 'White'
                }
              ) }
              onClick={ (): void => onClick(color) }
              style={ { backgroundColor: color } }
            />
          </Tooltip>))}
        { sortedColors.map(color => <Tooltip key={ color } content={ color } position='bottom'>
          <span
            className={ cx(
              colorFacetTermsColor,
              {
                [colorFacetTermsColorSelected]: selectedColors.includes(color),
                [colorFacetTermsColorOther]: color === 'Other',
                [colorFacetTermsColorWhite]: color === 'White'
              }
            ) }
            onClick={ (): void => onClick(color) }
            style={ { backgroundColor: color } }
          />
        </Tooltip>
        )}
      </div>
      {noColorsAvailable && (
        <Typography>No colors available</Typography>
      )}
    </FacetAccordion>);
};
